import { render, staticRenderFns } from "./TplBed.vue?vue&type=template&id=79b576c6&"
import script from "./TplBed.vue?vue&type=script&lang=js&"
export * from "./TplBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports